import { MIDWESTBANK_NAMESPACE_ID } from 'src/constants';
import {
  APPLICANT,
  SMARTMATCH_TYPE_LOAN_OFFICER,
  SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
  SMARTMATCH_TYPE_CLOSER,
  SMARTMATCH_TYPE_SALES,
  SMARTMATCH_TYPE_ADMIN_ISO,
  SMARTMATCH_TYPE_ACCOUNTING,
  SMARTMATCH_TYPE_LOAN_PROCESSOR_READER,
  SMARTMATCH_TYPE_UNDER_WRITER,
  SMARTMATCH_TYPE_LOAN_PROCESSOR,
  SMARTMATCH_TYPE_HIGH_CREST,
  STATUS_INVITATION_SENT
} from 'src/services/constants';
import {
  USER_ONBOARD_ADMIN,
  USER_ONBOARD_ADMIN_UNDERWRITER,
  USER_ONBOARD_LOAN_OFFICER_BACK_END,
  USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED,
} from 'src/services/constants/accounts';
import { CARDS, HOME_EQUITY, PERSONALLOANS, PURCHASE, REFINANCE, RESIDENTIAL_MORTGAGE, SECURED, UNSECURED, VISA_BUSINESS_CREDIT_CARD, VISA_PLATINUM_CREDIT_CARD } from 'src/features/LoansHome/Products/constants';
import {
  STATUS_SUBMITTED,
  STATUS_APPLICATION_APPROVED,
  STATUS_CLEAR_TO_CLOSE_COMPLETED,
  STATUS_DOCUMENTS_SIGNED,
  STATUS_LOAN_CLOSED,
  STATUS_FUNDING,
  STATUS_APPLICATION_STARTED,
  STATUS_WITHDRAW,
  STATUS_DECLINED,
  STATUS_APPROVED_NOT_ACCEPTED,
  STATUS_ARCHIVED,
  STATUS_UNDER_REVIEW,
  STATUS_COMPLETED,
  STATUS_APPROVED,
  STATUS_SUBMITTED_FOR_ORDER
} from 'src/services/constants';

const mkResidentialMortgageStageforAdmin = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_WITHDRAW,
    "display_name": STATUS_WITHDRAW
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          }
        ]
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          },
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_DOCUMENTS_SIGNED,
            "display_name": STATUS_DOCUMENTS_SIGNED
          },
          {
            "name": STATUS_FUNDING,
            "display_name": STATUS_FUNDING
          }
        ]
      }
    ],
    "name": STATUS_ARCHIVED,
    "display_name": STATUS_ARCHIVED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          },
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_DOCUMENTS_SIGNED,
            "display_name": STATUS_DOCUMENTS_SIGNED
          },
          {
            "name": STATUS_FUNDING,
            "display_name": STATUS_FUNDING
          }
        ]
      }
    ],
    "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
    "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_LOAN_CLOSED,
    "display_name": STATUS_LOAN_CLOSED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_APPROVED,
    "display_name": STATUS_APPLICATION_APPROVED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_APPROVED_NOT_ACCEPTED,
    "display_name": STATUS_APPROVED_NOT_ACCEPTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_DOCUMENTS_SIGNED,
    "display_name": STATUS_DOCUMENTS_SIGNED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_FUNDING,
    "display_name": STATUS_FUNDING
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          }
        ]
      }
    ],
    "name": STATUS_UNDER_REVIEW,
    "display_name": STATUS_UNDER_REVIEW
  }
]

const mkCardStageforAdmin = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_INVITATION_SENT,
            "display_name": STATUS_INVITATION_SENT
          },
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          },
          {
            "name": STATUS_UNDER_REVIEW,
            "display_name": STATUS_UNDER_REVIEW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          },
          {
            "name": STATUS_UNDER_REVIEW,
            "display_name": STATUS_UNDER_REVIEW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          },
          {
            "name": STATUS_SUBMITTED_FOR_ORDER,
            "display_name": STATUS_SUBMITTED_FOR_ORDER
          },
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          }
        ]
      }
    ],
    "name": STATUS_INVITATION_SENT,
    "display_name": STATUS_INVITATION_SENT
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          },
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          }
        ]
      }
    ],
    "name": STATUS_APPROVED,
    "display_name": STATUS_APPROVED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          },
          {
            "name": STATUS_SUBMITTED_FOR_ORDER,
            "display_name": STATUS_SUBMITTED_FOR_ORDER
          },
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          }
        ]
      }
    ],
    "name": STATUS_UNDER_REVIEW,
    "display_name": STATUS_UNDER_REVIEW
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          },
          {
            "name": STATUS_SUBMITTED_FOR_ORDER,
            "display_name": STATUS_SUBMITTED_FOR_ORDER
          },
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          }
        ]
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  },
    {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_COMPLETED,
    "display_name": STATUS_COMPLETED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          },
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          },
          {
            "name": STATUS_SUBMITTED_FOR_ORDER,
            "display_name": STATUS_SUBMITTED_FOR_ORDER
          },
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          }
        ]
      }
    ],
    "name": STATUS_ARCHIVED,
    "display_name": STATUS_ARCHIVED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_WITHDRAW,
    "display_name": STATUS_WITHDRAW
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_ARCHIVED,
            "display_name": STATUS_ARCHIVED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED_FOR_ORDER,
    "display_name": STATUS_SUBMITTED_FOR_ORDER
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_COMPLETED,
    "display_name": STATUS_COMPLETED
  }
]


const mkResidentialMortgageApplicantStage = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_APPROVED,
    "display_name": STATUS_APPLICATION_APPROVED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_DOCUMENTS_SIGNED,
            "display_name": STATUS_DOCUMENTS_SIGNED
          }
        ]
      }
    ],
    "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
    "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_FUNDING,
            "display_name": STATUS_FUNDING
          }
        ]
      }
    ],
    "name": STATUS_DOCUMENTS_SIGNED,
    "display_name": STATUS_DOCUMENTS_SIGNED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_FUNDING,
    "display_name": STATUS_FUNDING
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_LOAN_CLOSED,
    "display_name": STATUS_LOAN_CLOSED
  }
]

const mkCreditCardApplicantStage = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPROVED,
            "display_name": STATUS_APPROVED
          }
        ]
      }
    ],
    "name": STATUS_UNDER_REVIEW,
    "display_name": STATUS_UNDER_REVIEW
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED_FOR_ORDER,
            "display_name": STATUS_SUBMITTED_FOR_ORDER
          }
        ]
      }
    ],
    "name": STATUS_APPROVED,
    "display_name": STATUS_APPROVED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_COMPLETED,
            "display_name": STATUS_COMPLETED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED_FOR_ORDER,
    "display_name": STATUS_SUBMITTED_FOR_ORDER
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_COMPLETED,
    "display_name": STATUS_COMPLETED
  }
]

const MIDWEST_LOAN_STAGES_CONFIG = {
  id: '154878745215745754',
  namespace_id: MIDWESTBANK_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE, PERSONALLOANS],
  sub_loan_types: [
    SECURED, UNSECURED, HOME_EQUITY,
    PURCHASE, REFINANCE
  ],
  stages: mkResidentialMortgageStageforAdmin,
  roles: [
    USER_ONBOARD_ADMIN,
    SMARTMATCH_TYPE_LOAN_OFFICER,
    SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
    SMARTMATCH_TYPE_ADMIN_ISO,
    USER_ONBOARD_ADMIN_UNDERWRITER,
    SMARTMATCH_TYPE_UNDER_WRITER,
    SMARTMATCH_TYPE_LOAN_PROCESSOR,
    SMARTMATCH_TYPE_LOAN_PROCESSOR_READER,
    SMARTMATCH_TYPE_ACCOUNTING,
    SMARTMATCH_TYPE_SALES,
    SMARTMATCH_TYPE_HIGH_CREST,
    SMARTMATCH_TYPE_CLOSER,
    USER_ONBOARD_LOAN_OFFICER_BACK_END,
    USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED
  ],
};
const MIDWEST_CARDS_STAGES_CONFIG = {
  id: '154878745215745754',
  namespace_id: MIDWESTBANK_NAMESPACE_ID,
  loan_type: [CARDS],
  sub_loan_types: [VISA_PLATINUM_CREDIT_CARD, VISA_BUSINESS_CREDIT_CARD],
  stages: mkCardStageforAdmin,
  roles: [
    USER_ONBOARD_ADMIN,
    SMARTMATCH_TYPE_LOAN_OFFICER,
    USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED,
    SMARTMATCH_TYPE_LOAN_PROCESSOR
  ],
};

const MIDWESTBANK_CARD_STAGES_CONFIG_APPLICANT = {
  id: '154878745215745754',
  namespace_id: MIDWESTBANK_NAMESPACE_ID,
  loan_type: [CARDS],
  sub_loan_types: [VISA_PLATINUM_CREDIT_CARD, VISA_BUSINESS_CREDIT_CARD],
  stages: mkCreditCardApplicantStage,
  roles: [APPLICANT],
};
const MIDWESTBANK_LOAN_STAGES_CONFIG_APPLICANT = {
  id: '154878745215745754',
  namespace_id: MIDWESTBANK_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE, PERSONALLOANS],
  sub_loan_types: [
    SECURED, UNSECURED, HOME_EQUITY,
    PURCHASE, REFINANCE
  ],
  stages: mkResidentialMortgageApplicantStage,
  roles: [APPLICANT],
};

export const midwestBankLoanStages = [
  MIDWEST_LOAN_STAGES_CONFIG,
  MIDWEST_CARDS_STAGES_CONFIG,
  MIDWESTBANK_CARD_STAGES_CONFIG_APPLICANT,
  MIDWESTBANK_LOAN_STAGES_CONFIG_APPLICANT,
]